import React, { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './Modal.css';

export default function ModalCampania({ onClose, onCreado }) {
  const [form, setForm] = useState({ 
    titulo:'', 
    descripcion:'', 
    meta: 10000, 
    tipo:'otro', 
    urgente: false,
    prioridad: 1
  });
  const [loading, setLoading] = useState(false);

  const handle = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/campanias', form);
      toast.success(`¡Campaña "${form.titulo}" creada con éxito! 🎯`);
      onCreado(); 
      onClose();
    } catch (err) {
      toast.error('Error al crear la campaña');
    } finally { 
      setLoading(false); 
    }
  };

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal fade-up max-w-[500px]">
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>Nueva Opción de Donación</h2>
        <p className="modal-sub">Crea una causa para que la comunidad pueda apoyar</p>
        
        <form onSubmit={submit}>
          <div className="f-group">
            <label className="f-lbl">Título de la Campaña</label>
            <input 
              className="f-inp" 
              name="titulo" 
              placeholder="Ej: Alimento para Refugio Norte" 
              value={form.titulo} 
              onChange={handle} 
              required 
            />
          </div>

          <div className="f-row">
            <div className="f-group">
              <label className="f-lbl">Meta Financiera ($)</label>
              <input 
                className="f-inp" 
                name="meta" 
                type="number" 
                min="100" 
                value={form.meta} 
                onChange={handle} 
                required 
              />
            </div>
            <div className="f-group">
              <label className="f-lbl">Categoría</label>
              <select className="f-inp" name="tipo" value={form.tipo} onChange={handle}>
                <option value="alimento">🦴 Alimento</option>
                <option value="vacunas">💉 Salud / Vacunas</option>
                <option value="rescate">🐾 Rescate</option>
                <option value="infraestructura">🏠 Infraestructura</option>
                <option value="otro">✨ Otro</option>
              </select>
            </div>
          </div>

          <div className="f-group">
            <label className="f-lbl">Descripción de la Causa</label>
            <textarea 
              className="f-inp min-h-[100px] resize-y" 
              name="descripcion" 
              placeholder="Explica a los donantes por qué su apoyo es vital..." 
              value={form.descripcion} 
              onChange={handle} 
              required
            />
          </div>

          <div className={`p-4 border-2 border-rc rounded-2xl mb-5 ${form.urgente ? 'bg-red-50' : 'bg-transparent'}`}>
            <label className="flex items-center gap-3 font-bold cursor-pointer">
              <input 
                type="checkbox" 
                name="urgente" 
                checked={form.urgente} 
                onChange={handle} 
                className="w-5 h-5" 
              />
              Marcar como campaña URGENTE 🚨
            </label>
            {form.urgente && (
              <p className="text-xs text-r mt-2 ml-8">
                Esto resaltará la campaña en rojo en la pasarela de pagos.
              </p>
            )}
          </div>

          <button className="btn btn-v btn-full btn-lg" disabled={loading}>
            {loading ? 'Creando...' : 'Habilitar Opción de Donación'}
          </button>
        </form>
      </div>
    </div>
  );
}
